import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { ProfileEditModule } from '../profile-edit/profile-edit.module';
import { ContactComponent } from './contact.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { EditComponentGuard } from 'src/app/shared/guards/edit-component.guard';

const routes: Routes = [
  {
    path: '',
    component: ContactComponent,
    children: [
      { path: 'view', loadChildren: () => import('./view/view-contact.module').then(m => m.ViewContactModule) },
      { path: 'edit',canActivate: [EditComponentGuard],
      loadChildren: () => import('./edit/edit-contact.module').then(m => m.EditContactModule) },
      { path: '', redirectTo: 'view', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  declarations: [ContactComponent],
  imports: [
    ProfileEditModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SharedModule
  ]
})

export class ContactModule { }
